import isEqual from 'lodash.isequal';
import isObject from 'lodash.isobject';
import deepmerge from 'deepmerge';

import { getValue } from '../constants/getFieldValues';

const getDiff = (elkKey, draftKey, key = '', patronymic = '') => {
  if (isEqual(elkKey, draftKey)) return null;
  if (!elkKey) return draftKey;
  if (!draftKey) return elkKey;
  if (isObject(elkKey) && isObject(draftKey)) {
    if (key === 'isPatronymicAbsent' && patronymic) {
      return {
        value: getValue(elkKey),
        disabled: !!elkKey.disabled,
      };
    }
    return {
      value: getValue(elkKey) || getValue(draftKey),
      disabled: !!elkKey.disabled,
    };
  }
};

export function differenceObject(elkData, draftData) {
  if (!elkData && !draftData) return {};
  if (!draftData) return elkData;
  if (!elkData) return draftData;

  return Object.keys(deepmerge(elkData, draftData)).reduce((next, key) => {
    if (key === 'citizenship') {
      const citizenship = draftData[key] || elkData[key];
      return { ...next, citizenship };
    }
    const difference = getDiff(
      elkData[key],
      draftData[key],
      key,
      elkData['patronymic']
    );
    if (difference) {
      return { ...next, [key]: difference };
    }
    return next;
  }, {});
}

export function getDulDifferenceObject(elkData, draftData) {
  if (!elkData && !draftData) return {};
  if (!draftData) return elkData;
  if (!elkData) return draftData;
  return getValue(elkData.type) === getValue(draftData.type)
    ? differenceObject(elkData, draftData)
    : draftData;
}

export function isEmptyObject(obj: Record<any, any>) {
  return Object.keys(obj).length === 0;
}
